<template>
  <v-container style="min-height: calc(100vh - 80px);" class="my-5">
    <v-row justify="center">
      <v-col cols="12" md="12">
        <v-row>
          <v-col cols="12" md="12">
            <v-tabs centered>
              <v-tab
                class="text-capitalize"
                :to="{ name: 'Detailclass', query: { berita: check.berita } }"
                exact>
                <v-icon left>mdi-text-box-check-outline</v-icon> Pengumuman
              </v-tab>
              <v-tab
                class="text-capitalize"
                :to="{ name: 'Detailclasswork', query: { berita: check.berita } }"
                exact>
                <v-icon left>mdi-folder-text</v-icon> Tugas
              </v-tab>
              <v-tab
                class="text-capitalize"
                :to="{ name: 'Detailclasspeople', query: { berita: check.berita } }"
                exact>
                <v-icon left>mdi-calendar-month</v-icon> Anggota
              </v-tab>
              <v-tab
                v-if="false"
                class="text-capitalize"
                :to="{ name: 'Detailclassgrade', query: { berita: check.berita } }"
                exact>
                <v-icon left>mdi-calendar-month</v-icon> Nilai
              </v-tab>
            </v-tabs>
          </v-col>
          <v-col cols="12" md="12" v-if="alertdata.show">
            <alertsp :alertdata="alertdata" class="mb-0"></alertsp>
          </v-col>
          <v-col cols="12" md="12" v-if="loading.detail" class="text-center">
            <v-progress-circular
              :width="3"
              color="red"
              indeterminate>
            </v-progress-circular>
          </v-col>
          <v-col cols="12" md="12">
            <v-card
              flat
              v-if="!loading.detail && detaildata.length > 0">
              <v-img
                dark
                height="240px"
                :lazy-src="require('../../assets/default.jpg')"
                :src="api + '/upload/kelas/' + detaildata[0].bgimg_class">
                <v-app-bar
                  dark
                  flat
                  color="rgba(0, 0, 0, 0)">
                  <v-toolbar-title class="text-md-h4 font-weight-bold">
                    {{ detaildata[0].nama_class ? detaildata[0].nama_class : 'Class name' }}
                  </v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-btn
                    icon>
                    <v-icon>mdi-dots-vertical</v-icon>
                  </v-btn>
                </v-app-bar>
                <div class="px-5">
                  <div>
                    <span>
                      <v-icon left>mdi-qrcode-scan</v-icon>
                      <b>{{ detaildata[0].code_class ? detaildata[0].code_class : '-' }}</b>
                    </span>
                  </div>
                  <div>
                    <span>
                      <v-icon left>mdi-video-outline</v-icon>
                      <b>
                        <a
                          class="text-decoration-none yellow--text"
                          :href="'https://meet.google.com/lookup/pnb_' + detaildata[0].nama_class.replace(/ /g,'_')"
                          target="_blank">Get google meet link
                        </a>
                      </b>
                    </span>
                  </div>
                  <div class="mt-3">
                    <div class="caption font-weight-bold">{{ detaildata[0].prodi_class }}</div>
                    <div class="caption font-weight-bold">Semester {{ detaildata[0].semester_class }}</div>
                    <div class="caption font-weight-bold">{{ detaildata[0].matkul_class }}</div>
                    <div class="caption font-weight-bold">{{ detaildata[0].angkatan_class }} - {{ detaildata[0].mhs_class }}</div>
                  </div>
                </div>
              </v-img>
              <v-card-text>
                <v-row class="black--text">
                  <v-col cols="12" md="3">
                    <h6 class="text-h6">Upcoming</h6>
                    <router-link
                      v-for="(upcom, i) in upcominglist"
                      :key="i"
                      class="link-list-style text-decoration-none"
                      :to="{ name: 'Detailclass' }">
                      <div
                        class="item-list-style py-2">
                        <div class="text-caption">Due {{ upcom.duedate_post }}</div>
                        <div class="text-subtitle-1">{{ upcom.title_post }}</div>
                      </div>
                    </router-link>
                  </v-col>
                  <v-col cols="12" md="9">
                    <v-card
                      v-for="(anno, i) in announcelist"
                      :key="i"
                      outlined>
                      <v-card-text class="d-flex">
                        <router-link
                          class="link-list-style text-decoration-none"
                          :to="{ name: 'Detailclass' }">
                          <div>
                            <v-btn
                              outlined
                              class="mr-2"
                              fab
                              small
                              dark
                              color="primary">
                              <v-icon>mdi-book</v-icon>
                            </v-btn>
                            <b>{{ anno.content_anno }}</b>
                          </div>
                        </router-link>
                        <v-spacer></v-spacer>
                        <v-row
                          align="center"
                          justify="end">
                          <span class="text-right caption font-weight-bold">
                            {{ anno.posted_at_anno }}
                          </span>
                          <span class="text-right ml-2">
                            <v-menu
                              offset-y
                              bottom
                              left
                              nudge-bottom="10"
                              transition="scale-transition">
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  color="primary"
                                  class="text-capitalize"
                                  icon
                                  v-bind="attrs"
                                  v-on="on"
                                  exact>
                                  <v-icon>mdi-dots-vertical</v-icon>
                                </v-btn>
                              </template>
                              <v-list>
                                <v-list-item>
                                  <v-list-item-title>View</v-list-item-title>
                                </v-list-item>
                              </v-list>
                            </v-menu>
                          </span>
                        </v-row>
                      </v-card-text>
                    </v-card>
                  </v-col>
                  <v-col cols="12" md="12">
                    <div class="mt-5 text-center">
                      <v-btn
                        class="mr-2 mb-2"
                        fab
                        depressed
                        dark
                        x-small
                        :to="{ name: 'Listclass' }">
                        <v-icon dark>
                          mdi-arrow-left-thick
                        </v-icon>
                      </v-btn>
                      <span class="title">Daftar kelas</span>
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import qs from 'qs';
import Alertsp from '../../components/Alert.vue';
import { mapState } from 'vuex';

export default {
  name: 'Detailclass',
  data: () => ({
    alertdata: {
      show: false,
      type: 'warning',
      text: '',
    },
    loading: {
      detail: false,
      upcoming: false,
      announce: false,
    },
    api: process.env.VUE_APP_API,
    maincolor: process.env.VUE_APP_MAINCOLOR,
    publickey: '123',
    detaildata: [],
    upcominglist: [],
    announcelist: [],
    panduan: null,
    paramberita: {
      search: '',
      limit: '',
      offset: '',
    },
    check: {
      berita: '',
    },
    formcheck: {
      valid: false,
    },
    rules: {
      required: (value) => !!value || 'Required.',
    },
    hasil: {
      headers: [
        { text: 'Tahun', value: 'tahun_prestasi' },
        { text: 'Peringkat', value: 'juara_prestasi' },
        { text: 'Tingkat', value: 'tingkat_prestasi' },
      ],
      data: [],
    },
  }),
  watch: {
    '$route.query.berita'(val) {
      if (val) {
        this.check.berita = val;
        this.getClass();
      }
    },
  },
  mounted() {
    if (this.$route.query.berita && this.$route.query.berita !== '') {
      this.check.berita = this.$route.query.berita;
      this.getClass();
    }
  },
  created: () => ({
  }),
  computed: {
    ...mapState([
      'isAuth',
      'tokenpub',
      'tokenscr',
      'userrole',
    ]),
  },
  methods: {
    getClass() {
      this.loading.detail = true;
      this.alertdata.show = false;
      if (this.check.berita) {
        this.axios
          .get(
            this.api + '/api/kelas/teacher/' + this.check.berita,
            {
              params: this.paramberita,
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const resdata = res.data;
              // console.log(resdata);
              if (resdata.error === false) {
                this.detaildata = resdata.data;
                this.getAnnounce();
                this.getUpcoming();
              } else {
                this.alertdata.show = true;
                this.alertdata.type = 'error';
                this.alertdata.text = resdata.message;
              }
            } else {
              this.alertdata.show = true;
              this.alertdata.type = 'error';
              this.alertdata.text = 'Internal services error!';
            }
            this.loading.detail = false;
          })
          .catch((error) => {
            console.log(error);
            this.loading.detail = false;
            this.alertdata.show = true;
            this.alertdata.type = 'error';
            this.alertdata.text = 'Internal services error!';
          });
      } else {
        this.loading.detail = false;
        this.alertdata.show = true;
        this.alertdata.type = 'error';
        this.alertdata.text = 'Berita tidak ditemukan!';
      }
    },
    getAnnounce() {
      if (this.tokenscr) {
        this.loading.announce = true;
        this.axios
          .get(
            this.api + '/api/announce/class/' + this.check.berita,
            {
              params: {
              },
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const resdata = res.data;
              console.log(resdata);
              if (resdata.error === false) {
                this.announcelist = resdata.data;
              }
            }
            this.loading.announce = false;
          })
          .catch((error) => {
            console.log(error);
            this.loading.announce = false;
          });
      }
    },
    getUpcoming() {
      if (this.tokenscr) {
        this.loading.upcoming = true;
        this.axios
          .get(
            this.api + '/api/post/upcomming/' + this.check.berita,
            {
              params: {
              },
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const resdata = res.data;
              if (resdata.error === false) {
                this.upcominglist = resdata.data;
              }
            }
            this.loading.upcoming = false;
          })
          .catch((error) => {
            console.log(error);
            this.loading.upcoming = false;
          });
      }
    },
  },
  components: {
    Alertsp,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
